import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import EditCrew from '../../shared/EditCrew';

const CrewModal = ({ crew, equipment, onChange, onConfirm, onHide, resources, show }) => (
  <Modal onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>
        <FontAwesome name="pencil" /> Edit Crew
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <EditCrew
        crew={crew}
        showpercentage={true}
        equipment={equipment}
        onChange={onChange}
        resources={resources}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Cancel</Button>
      <Button bsStyle="primary" onClick={onConfirm}>Save</Button>
    </Modal.Footer>
  </Modal>
);

export default CrewModal;
